<template>
    <div>
        <div class="flex justify-end">
            <label for="reserve-modal" class="btn btn-info">Foglalás hozzáadása</label>
        </div>
        <table class="table table-zebra w-full mt-5 -z-0">
            <thead>
                <tr>
                    <th>Szoba</th>
                    <th>Neptun</th>
                    <th>Státusz</th>
                    <th>Módosító</th>
                    <th>Műveletek</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="reservation in reservations" :key="reservation.id" class="hover">
                    <td>{{ reservation.room_name }}</td>
                    <td>{{ reservation.neptun }}</td>
                    <td>{{ getStatus(reservation.status, reservation.last_modified_by) }}</td>
                    <td>{{ reservation.last_modified_by }}</td>
                    <td>
                        <div class="btn-group">
                            <label
                                class="btn btn-info"
                                @click="setModel(reservation)"
                                for="reserve-modal"
                            >
                                Szerkesztés
                            </label>
                            <label
                                class="btn btn-error"
                                @click="setModel(reservation)"
                                for="delete-modal"
                            >
                                Kidobás
                            </label>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Put this part before </body> tag -->
        <input type="checkbox" id="reserve-modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box grid gap-3">
                <div class="flex justify-between">
                    <h3 class="font-bold text-lg">Engedélyezet felhasználó szerkesztése</h3>
                    <label
                        for="reserve-modal"
                        @click="setModel({})"
                        class="btn btn-sm btn-error btn-square cursor-pointer fill-base-content text-base-100 absolute right-2 top-2"
                    >
                        <CloseIcon transparent/>
                    </label>
                </div>
                <div class="grid gap-3">
                    <div class="form-control w-full">
                        <label>Szobaszám</label>
                        <input class="input outline" v-model="model.room_name" />
                    </div>
                    <div class="form-control w-full">
                        <label>Neptun</label>
                        <input class="input outline" v-model="model.neptun" />
                    </div>
                    <div class="form-control w-full">
                        <label>Státusz</label>
                        <select v-model="model.status" class="select select-bordered">
                            <option value="ASSIGNED">Beosztott, nem költözhet</option>
                            <option value="INVITED">Meghívott (elfogadásra vár)</option>
                            <option value="APPLIED">Jelentkezett (elfogadásra vár)</option>
                            <option value="RESERVED">Lefoglalt</option>
                        </select>
                    </div>
                    <div v-show="model.status === 'RESERVED'" class="form-control w-full">
                        <label>Előjog</label>
                        <input type="checkbox" class="checkbox" v-model="model.system_reserve" />
                    </div>
                </div>
                <div class="modal-action">
                    <label
                        for="reserve-modal"
                        class="btn btn-outline w-full"
                        @click="
                            model.id ? updateReservationAsync(model) : storeReservationAsync(model);
                            setModel({});
                        "
                    >
                        Mentés
                    </label>
                </div>
            </div>
        </div>

        <!-- Put this part before </body> tag -->
        <input v-model="modal" type="checkbox" id="delete-modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box relative">
                <label
                    for="delete-modal"
                    @click="setModel({})"
                    class="btn btn-sm btn-error btn-square cursor-pointer fill-base-content text-base-100 absolute right-2 top-2"
                >
                    <CloseIcon transparent/>
                </label>
                <h3 class="text-lg font-bold">Hallgató {{ model.neptun }} kidobása a szobából</h3>
                <div class="py-4">
                    <label
                        for="delete-modal"
                        @click="
                            deleteReservationAsync(model);
                            setModel({});
                        "
                        class="btn btn-error w-full"
                    >
                        Kidobás
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CloseIcon from "../svg/CloseIcon";

export default {
    name: 'Reservations',
    components: { CloseIcon },
    props: {
        period_id: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            model: { period_id: this.period_id },
            modal: {},
        };
    },
    computed: {
        ...mapGetters('Period', ['reservations']),
    },
    methods: {
        ...mapActions('Period', [
            'getReservationsAsync',
            'storeReservationAsync',
            'updateReservationAsync',
            'deleteReservationAsync',
        ]),
        setModel(model) {
            this.model = { ...model, period_id: this.period_id };
        },
        getStatus(status, user) {
            switch (status) {
                case 'ASSIGNED':
                    return 'Beosztott, nem költözhet';
                case 'INVITED':
                    return 'Meghívott (elfogadásra vár)';
                case 'APPLIED':
                    return 'Jelentkezett (elfogadásra vár)';
                case 'RESERVED':
                    return user === 'system' ? 'Előjoggal lefoglalt' : 'Lefoglalt';
            }
            return 'Érvénytelen státusz';
        },
    },
    mounted() {
        this.getReservationsAsync(this.period_id);
    },
};
</script>

<style scoped></style>
